export enum ESearchStatus {
  BEFORE_SEARCH = 'BEFORE_SEARCH',
  KEYWORD_TO_SHORT = 'KEYWORD_TO_SHORT',
  RESULT_EXISTS = 'RESULT_EXISTS',
  EMPTY_RESULT = 'EMPTY_RESULT',
}
